import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/components/Button/Button";
import { HOMEPAGE } from "~/utils/url/staticUrls";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { IMG_SELF_REGISTRATION_SUCCESS } from "~/utils/url/staticResources";

export const Success = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "24px",
        maxWidth: "460px",
        marginInline: "auto",
        textAlign: "center",
      }}
      className={className}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <CheckCircleOutlineIcon fontSize={"large"} color={"primary"} />
        <Typography variant="headlineMedium">{t("page.selfRegistration.success.title")}</Typography>
      </Box>

      <img src={IMG_SELF_REGISTRATION_SUCCESS} alt="" />
      <Typography variant="bodyLarge">{t("page.selfRegistration.success.text")}</Typography>
      <Button href={HOMEPAGE}>{t("page.selfRegistration.success.button")}</Button>
    </Box>
  );
};
